import React from 'react';
import './App.scss';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import AppContent from './components/AppContent/AppContent';
import FAQ from './components/MainMenu/MainMenuPages/FAQ';
import ContactUs from './components/MainMenu/MainMenuPages/ContactUs';
import PrivacyPolicyRedirect from './PrivacyPolicyRedirect';
import CookiePolicyRedirect from './CookiePolicyRedirect';
import TermsConditionsRedirect from './TermsConditionsRedirect';
import { GoogleMapsApiProvider } from './GoogleMapsApiContext';
import { ProfileNavigationProvider } from './contexts/ProfileNavigationContext';
import { ModalControllerProvider } from './contexts/ModalControllerContext';
import ResetPasswordPage from './pages/ResetPasswordPage/ResetPasswordPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage/PaymentSuccessPage';
import PaymentCancelledPage from './pages/PaymentCancelledPage/PaymentCancelledPage';
import ClaimListingPage from './pages/ClaimListingPage/ClaimListingPage';
import SharedPriceEstimationPage from './pages/SharedPriceEstimationPage/SharedPriceEstimationPage';

const App = () => {
  return (
    <ErrorBoundary>
    <GoogleMapsApiProvider>
      <div className="App-wrapper">
      <Router>
        <ProfileNavigationProvider>
        <ModalControllerProvider>
        <div className="App-content">
          <Switch>
            <Route exact path="/" render={() => <AppContent />} />
            <Route path="/could-sell" render={() => <AppContent />} />
            <Route path="/could-buy" render={() => <AppContent />} />
            <Route path="/direct-messages" render={() => <AppContent />} />
            <Route path="/activities" render={() => <AppContent />} />
            <Route path="/profile/price-estimations/:estimation_id" render={() => <AppContent />} />
            <Route path="/profile/price-estimations" render={() => <AppContent />} />
            <Route path="/profile/sell-listings" render={() => <AppContent />} />
            <Route path="/profile/buy-listings" render={() => <AppContent />} />
            <Route path="/profile" render={() => <AppContent />} />
            <Route path="/faq" component={FAQ} />
            <Route path="/contact" component={ContactUs} />
            <Route path="/terms-conditions" component={TermsConditionsRedirect} />
            <Route path="/cookie-policy" component={CookiePolicyRedirect} />
            <Route path="/privacy-policy" component={PrivacyPolicyRedirect} />
            <Route path="/reset-password/:token" component={ResetPasswordPage} />
            <Route path="/payment-success" component={PaymentSuccessPage} />
            <Route path="/payment-cancelled" component={PaymentCancelledPage} />
            <Route path="/sell/claim/:token" component={ClaimListingPage} />
            <Route path="/price-estimation-report/:estimationId" component={SharedPriceEstimationPage} />
            <Route
            path="/listing/:id/:slug?"
            render={() => <AppContent />}
          />
          </Switch>
          </div>
        </ModalControllerProvider>
        </ProfileNavigationProvider>
        </Router>
      </div>
    </GoogleMapsApiProvider>
    </ErrorBoundary>
  );
};

export default App;
